export default "__VITE_ASSET__0863bfc8__"